/**
 * Fixed Phase 1 questions whose options live in `alma_question_options`
 * (managed at /admin/alma-questions). Cities and priorities have their own
 * tables (`destinations`, `host_specialties`), and branch questions are rows
 * in `alma_question_branches`, so neither is listed here.
 */
export interface AlmaOptionList {
  /** `alma_question_options.question_key`. */
  key: string;
  /** Section title in the admin. */
  title: string;
  /** One line explaining where the list shows up. */
  description: string;
  /** Rows may carry per-group wording (label_solo / label_partner / label_group). */
  perGroupLabels: boolean;
}

export const ALMA_OPTION_LISTS: AlmaOptionList[] = [
  {
    key: 'walking_comfort',
    title: 'How much walking is comfortable',
    description: 'Last question for everyone. Per-group wording replaces the default for that group.',
    perGroupLabels: true,
  },
];

/** Turns a branch title into a `question_key`, e.g. "Where you'd like to eat" → "where_youd_like_to_eat". */
export function questionKeyFromTitle(title: string, taken: string[]): string {
  const base = title.trim().toLowerCase().replace(/[^a-z0-9\s]/g, '').replace(/\s+/g, '_') || 'branch';
  let key = base;
  for (let n = 2; taken.includes(key); n++) key = `${base}_${n}`;
  return key;
}
